/* eslint-disable */
import axios from 'axios'
import config from '@assets/config.json'
import qs from 'qs'

// 通用 Module
const state = {
  login: false, // 登录状态
  token: '', // 请求token
  user: null, // 用户信息
  role: 0, // 0 = 展商   1 = 主办   2 = 展商（英文版）
  commonHeader: {
    headers: { 'Content-Type': 'application/json; charset=utf-8;' }
  },
  header: '',
  tokenHeaders: '',
  tokenTime: 0, // token过期时间
  auth: '', // 请求token的数据
  formHeaders: {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  },
  uploadUrl: `${config.api.reqApi}/api/upload/images`, // 图片上传地址
  uploadUrl2: `${config.api.reqApi}/api/upload/files`, // 图片上传地址
  uploadVideoUrl: `${config.api.reqApi}/api/upload/videos`, // 视频上传地址
  reqApi: `${config.api.reqApi}/api/upload/videos`, // 视频上传地址
  refresh: true,

  isZh: true
}
const mutations = {
  updateValue(state, payload) {
    state.isZh = payload
  },

  setToken(state, data) {
    if (data) {
      state.tokenHeaders = {
        headers: {
          Authorization: 'Bearer ' + data,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      state.header = {
        headers: {
          Authorization: 'Bearer ' + data,
          'Content-Type': 'application/json; charset=utf-8;'
        }
      }
    }
    state.token = data
  },
  setTokenTime(state, data) {
    state.tokenTime = data
  },
  setRefreshStatus(state, data) {
    state.refresh = data
  },
  setLogin(state, data) {
    state.login = data
  },
  setUser(state, data) {
    state.user = data
  },
  setAuth(state, data) {
    state.auth = data
  },
  setRole(state, data) {
    state.role = data
  }
}
const getters = {
  getUploadUrl: (state) => {
    return state.uploadUrl
  },
  getUploadUrl2: (state) => {
    return state.uploadUrl2
  },
  getUploadVideoUrl: (state) => {
    return state.uploadVideoUrl
  },
  getFormHeaders: (state) => {
    return state.formHeaders
  },
  getRefreshStatus: (state) => {
    return state.refresh
  },
  getTokenTime: (state) => {
    return state.tokenTime
  },
  getToken: (state) => {
    const token = state.token || localStorage.getItem('token')
    state.token = token
    return state.token
  },
  getUser: (state) => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user && !state.user) {
      state.user = user
    }
    return state.user
  },
  getLogin: (state) => {
    const login = JSON.parse(localStorage.getItem('login'))
    if (login) {
      state.login = login
    }
    return state.login
  },
  getAuth: (state) => {
    return state.auth
  },
  getRole: (state) => {
    return state.role
  }
}
const actions = {
  /**
   *  获取数据类型通用写法封装
   * @param {*} param0 
   * @param {*} data { url: '基础接口的传入字符串', opt: 分页请求的参数}
   * url替换 <控制器名称>  【 /api/v1/<控制器名称>/wherepage 】
   *opt:  pageSize 页条数
          pageIndex 页码
          sorts[] 排序属性 
            propertyName 属性名称（必须是实体属性名称，且区分大小写，如果属性名称以小写开头，请把首字母大写）
            ascending 是否升序
          wheres 条件集
            type 条件类型
              0 条件组
              1 字段
              2 在值1与值2之间
              3 不在值1与值2之间
              4 符合给定的条件
              5 不符合给定的条件
            wheres 条件对象
   */
  getWherepage({ state }, data) {
    return new Promise((resolve, reject) => {
      const defaultOpt = {
        pageSize: 1000,
        sorts: [{ propertyName: 'showIndex', ascending: true }]
      }
      const opt = data.opt
        ? Object.assign({}, defaultOpt, data.opt)
        : defaultOpt
      axios
        .post(`${state.reqApi}/api/v1/${data.url}/wherepage`, opt)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  //获取国家 新
  getCountryNew({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `https://oss-ecrm.reed-sinopharm.com/host/data-to-blob/countries/country-province-city-county.json`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getStaff({ state }, id) {
    // 获取客服
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/staff/GetDefault?compId=${id}`,
          state.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  uploadImages({ state }) {
    // 上传图片
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/upload/images`, {}, state.formHeaders)
        .then((data) => {
          if (data.data) {
            if (data.data.successed) {
              Message.success('验证码已发送')
            } else {
              Message.success('验证码发送失败')
            }
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  refreshToken({ state, rootGetters, rootState, commit }) {
    console.log('refreshToken')
    const opt = {
      grant_type: 'refresh_token',
      client_id: 'cloud.exhibition',
      client_secret: 'secret',
      refresh_token: state.auth.refresh_token
    }
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/connect/token`,
          qs.stringify(opt),
          rootState.formHeaders
        )
        .then((data) => {
          if (data.data) {
            commit('setAuth', data.data, { root: true })
            commit('setToken', data.data.access_token, { root: true })
            commit(
              'setTokenTime',
              data.data.expires_in * 1000 + new Date().getTime(),
              { root: true }
            )
            commit('setRefreshStatus', true, { root: true })
            resolve(data.data)
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log(err.response.data)
          }
        })
    })
  },

  // 企业动态模块
  addNews({ rootState }, opt) {
    // 添加
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/NewsExhibitor`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  getNewsByJoinId({ rootState }, opt) {
    // 根据参展Id分页获取
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/NewsExhibitor/GetByJoinId`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  getNewsById({ rootState }, id) {
    // 根据Id获取详情
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/NewsExhibitor?id=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  putNews({ rootState }, opt) {
    // 修改
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/NewsExhibitor`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  delNews({ rootState }, id) {
    // 删除
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `${config.api.reqApi}/api/NewsExhibitor?id=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  delLink({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/Contact`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },

  // 实名验证
  // realAuth({ rootState }, opt) {
  //   let header = {
  //     headers: {
  //       "Authorization": "APPCODE " + "17b7faa1dfd9477fa1dc823fec21a7c8",
  //       "Content-Type": rootState.header.headers['Content-Type']
  //     }
  //   }
  //   return new Promise((resolve, reject) => {
  //     axios.get(`https://idcert.market.alicloudapi.com/idcard?idCard=${opt.idCard}&name=${opt.name}`, header).then(data => {
  //       if (data.data) {
  //         resolve(data.data);
  //       } else {
  //         resolve(null);
  //       }
  //     }).catch((err) => {
  //       console.log(err.response.data);
  //     });
  //   });
  // },

  // 实名认证
  realAuth({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/IDCard/Check`,
          opt,
          rootState.formHeaders.headers
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  //获取短信模板
  getNote({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/SmsTemp/GetAllModule`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  getOnlyMouder({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/SmsTemp/GetByModuleOnly?module=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  //保存编辑短信模板
  editSmsTemp({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/SmsTemp/Save`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  //获取短信账号
  getSmsAccount({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/SmsAccount/GetInfo`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  //保存短信账号
  SmsAccountSave({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/SmsAccount/Save`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  //获取展位信息列表
  getexInformation({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ApplyScene/GetList`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  getexInformationExcel({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ApplyScene/ExcelExport`, opt, {
          responseType: 'arraybuffer',
          ...rootState.header
        })
        .then((data) => {
          if (data.data) {
            const aLink = document.createElement('a')
            let blob = new Blob([data.data], {
              type: 'application/vnd.ms-excel'
            })
            aLink.href = URL.createObjectURL(blob)
            aLink.setAttribute('download', '展位预定信息' + '.xlsx') // 设置下载文件名称
            aLink.click()
            //document.body.appendChild(aLink)
            this.$refs.loadElement.appendChild(aLink)

            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  //查询短信余额
  getHostSmsMargin({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/SmsAccount/GetBalance`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          } else {
            resolve(null)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
    },

    // 获取展区列表
    getAllArea ({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(
                    `${config.api.reqApi}/api/ThirdPartyInfo/getAllArea?exhibitionId=${id}&isEnable=true`,
                    rootState.header
                )
                .then((data) => {
                    if (data.data) {
                        resolve(data.data)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        })
    },
    //   /api/ThirdPartyInfo/getCommodities 获取商品信息
    getCommodities ({ rootState }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `${config.api.reqApi}/api/ThirdPartyInfo/getCommodities`,
                    opt,
                    rootState.header
                )
                .then((data) => {
                    if (data.data) {
                        resolve(data.data)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        })
    }

}
export default {
  state,
  actions,
  mutations,
  getters
}
